import { createRfpGuideHttpClient } from '../infra/createRfpGuideHttpClient'
import { ProposalRepository } from '../infra/ProposalRepository'

export type UploadRfpLanesFileParams = {
  uploadParams: {
    rfpId: string
    rateType: string
    file: File
  }
  config?: { signal: AbortSignal }
}

export type UploadRfpLanesFileFactoryDependencies = {
  proposalRepository: ProposalRepository
}

export function uploadRfpLanesFileFactory({
  proposalRepository,
}: UploadRfpLanesFileFactoryDependencies) {
  return async function uploadRfpLanes({ uploadParams, config }: UploadRfpLanesFileParams) {
    const uploadMethod = proposalRepository.uploadRfpLanesFileV2(uploadParams, config)

    try {
      return await uploadMethod
    } catch (error) {
      throw new Error('Failed to upload rate lanes file', { cause: error as Error })
    }
  }
}

export function uploadRfpLanesFile(uploadParams: UploadRfpLanesFileParams) {
  const proposalRepository = new ProposalRepository({ httpClient: createRfpGuideHttpClient() })
  const upload = uploadRfpLanesFileFactory({ proposalRepository })

  return upload(uploadParams)
}
